import axios from 'axios'

// initial state
const state = () => ({
    progressparameter: [],
})

// getters
const getters = {
  progressparameter: ({ progressparameter }) => progressparameter,
}

// actions
const actions = {
    async getProgressParameter({ commit }) {
        const progressparameter = (await axios.get('/meta/progressparameter/')).data
        commit('setProgressParameter', progressparameter)
    },
}

// mutations
const mutations = {
    setProgressParameter(state, progressparameter) {
        state.progressparameter = progressparameter
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
